
<template>
  <div>
    <div class="hgrad" :style="getGradientStyle()">
      <template v-for="index in getThresholdLength()">
        <div  class="wi"
              v-bind:class="{ fs: smallFont, fl: !smallFont, pw1: proportional, pwf: !proportional }"
              :style="getWidth(index-1)"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="tooltipText(index-1)"
              :key="`${index}_result`">
          {{ displayTextConditional(index-1) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default {
  name: 'Scale',

  mixins: [ AppConfig ],

  props: {
    proportional:  { type: Boolean, default: true },
    smallFont:  { type: Boolean, default: false },
    showText:  { type: Boolean, default: false },
    thresholds: null // default values are defined in Foot.vue!
  },

  // created() {
  //     console.log("Scale - created - thresholds: " + JSON.stringify(this.thresholds));
  // },

  methods: {
    tooltipText(index) {
      let retVal ='';

      if (this.showText && this.thresholds && this.thresholds.length > index) {
        retVal = this.thresholds.Minimum + '-' + this.thresholds.Maximum + '%';
      }

      return retVal;
    },

    displayTextConditional(index) {
      let retVal ='';

      if (this.showText && this.thresholds && this.thresholds.length > index) {
        retVal = this.thresholds.Minimum + '-' + this.thresholds.Maximum + '%';
      }

      return retVal;
    },

    getThresholdLength() {
      return this.thresholds ? this.thresholds.length : 0;
    },

    getWidth(index) {
      let retVal ='width=0px;';

      if (this.thresholds && this.thresholds.length > index) {
        retVal = 'width=' + (this.thresholds[index].Maximum - this.thresholds[index].Minimum) + '%;';
      }

      // console.log("Scale - getWidth: " + retVal);

      return retVal;      
    },

    getGradientStyle() {
      let retVal = '';

      if (this.thresholds) {

        retVal = "background: linear-gradient(90deg, ";

        for (let i=0; i<this.thresholds.length; i++) {
          
          if (i > 0) {
            retVal += this.thresholds[i].Color + ' ' + this.thresholds[i].Minimum + '%';
            if (i < this.thresholds.length - 1) {
              retVal += ', ';
            }
          }

          if (i < this.thresholds.length - 1) {
            retVal += this.thresholds[i].Color + ' ' + this.thresholds[i].Maximum + '%, ';
          }

        }

        retVal += ');';
      }
      // console.log("Scale - getGradientStyle: " + retVal);

      return retVal;
    },

  }
};

</script>


<style scoped>

.wi {
  height: 100%;
  float: left;
  color: #222;
  text-shadow:
  -.25px -.25px 0 #666,
  .25px -.25px 0 #666,
  -.25px .25px 0 #666,
  .25px .25px 0 #666;
}

.fl {
  font-size: 11px;
}
.fs {
  font-size: 9px;
}

.hi {
  /* padding-top: 2px; */
  color: #222;
  text-align: center;
  line-height: 0.5rem;
  text-shadow:
  -.25px -.25px 0 #666,
  .25px -.25px 0 #666,
  -.25px .25px 0 #666,
  .25px .25px 0 #666;
}
.hgrad {
  border-radius: 3px;
  height: 100%;
  width: 100%;
  /* background: linear-gradient(90deg, #ff201c 34%, #f7850E 34%, #f7850E 59%, #FDF804 59%, #FDF804 74%, #96E524 74%, #96E524 90%, #0C891D 90%); */
}

/* .hgradf{
  border-radius: 3px;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #ff201c 20%, #f7850E 20%, #f7850E 40%, #FDF804 40%, #FDF804 60%, #96E524 60%, #96E524 80%, #0C891D 80%);
} 
.vgrad {
  border-radius: 3px;
  height: 100%;
  max-width: 155px;
  width: 100%;
  background: linear-gradient(180deg, #0C891D 10%, #96E524 10%, #96E524 26%, #FDF804 26%, #FDF804 41%, #f7850E 41%, #f7850E 66%, #ff201c 66%);
}
.vgradf{
  border-radius: 3px;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #0C891D 20%, #96E524 20%, #96E524 40%, #FDF804 40%, #FDF804 60%, #f7850E 60%, #f7850E 80%, #ff201c 80%);
} */

</style>
